import React from 'react';

const ThirdPartyAgreement = () => {
    return (
        <div className="privacy-policy-content">
            <h3>&lt;제3자정보제공&gt;</h3>
            <p>
                안세회계법인 (이하 "회사" 이라 함)는 귀하의 개인정보보호를 매우 중요시하며, 
                『개인정보보호법』을 준수하고 있습니다. 회사는 개인정보취급방침을 통하여 귀하께서 제공하시는 
                <br />

                개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 
                취해지고 있는지 알려드립니다.
            </p>

            <p>이 개인정보취급방침의 순서는 다음과 같으며, 본 방침은 2021 년 6 월 1 일 부터 시행됩니다.</p>

            <div className="policy-content">
                <p>
                    1. 개인정보 수집 · 이용 목적, 항목, 방법 <br />
                    2. 개인정보 보유 · 이용기간, 파기절차, 파기방법 <br />
                    3. 개인정보를 제 3자에게 제공하는 경우, 제공 받는 자의 성명, 이용 목적, 제공항목 <br />
                    ※ 개인정보를 제3자에게 제공하는 경우, 포함하여 작성 <br />
                    4. 취급 위탁 업무 내용, 수탁자 <br />
                    ※ 개인정보 취급위탁을 하는 경우, 포함하여 작성 <br />
                    5. 이용자 및 법정대리인 권리와 그 행사방법 <br />
                    6. 자동수집장치 설치, 운영, 거부 <br />
                    7. 개인정보관리책임자 성명(또는 부서), 연락처
                </p>

                <h4>1. 개인정보 수집 · 이용 목적, 항목, 방법</h4>
                <p>
                    - 이용목적 : 고객문의 처리 <br />
                    - 수집항목 : 성명, 나이, 연락처, 상담내용 <br />
                    - 수집방법 : 홈페이지 내 온라인 간편문의 양식
                </p>

                <h4>2. 개인정보 보유 · 이용기간, 파기절차, 파기방법</h4>
                <p>
                    - 보유 · 이용기간 : 1년 <br />
                    - 파기절차 : 이용자가 입력한 개인정보는 목적(고객문의 처리)이 달성 된 후 별도의 DB로 옮겨져 
                      (종이의 경우 별도의 서류함) 정보통신망법 시행령에서 정한 보유기간(1년) 동안 저장된 후 파기 됩니다. <br />
                    - 파기방법 : 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
                      종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                </p>

                <h4>3. 개인정보를 제 3자에게 제공하는 경우</h4>
                <p>회사는 개인정보를 제3자에게 제공하지 않습니다.</p>

                <h4>4. 취급 위탁 업무 내용, 수탁자</h4>
                <p>
                    회사는 서비스 향상을 위해서 개인정보 수집을 위탁 할 수 있으며, 위탁시에는 관계법령에 따라 
                <br />
                위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 이를 본 개인정보 취급방침에 
                    반영하고 공지를 통하여 회원에게 공개하겠습니다.
                </p>

                <h4>5. 이용자 및 법정대리인 권리와 그 행사방법</h4>
                <p>
                    - 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인정보를 수정, 가입해지를 요청할 수 있습니다. <br />
                    - 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다. <br />
                    - 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "2. 개인정보 보유 · 이용기간, 
                      파기절차, 파기방법" 에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
                </p>

                <h4>6. 자동수집장치 설치, 운영, 거부</h4>
                <p>
                    - 회사는 이용자에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의 정보를 수시로 저장하고 찾아내는 
                      "쿠키(cookie)" 등을 운용합니다. <br />
                    - 쿠키 설정 거부 방법 : 이용자가 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 
                      쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
                </p>

                <h4>7. 개인정보관리책임자 성명(또는 부서), 연락처</h4>
                <p>- 부서 : 온라인 마케팅팀 / 연락처 : 02-829-7575</p>
            </div>
        </div>
    );
};

export default ThirdPartyAgreement;
